import script from "./JaStreamGroupConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupConfirm.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupConfirm.vue?vue&type=style&index=0&id=ad188ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad188ae6"]])

export default __exports__